export default "__VITE_ASSET__8cfd45e9__"